import utils from '@/mixins/utils.js'

// Função para verificar pendências baseada nos alertas da TabelaCadastros.vue
function verificarPendencias(item) {
  const pendencias = []

  // Colo útero (a_pb) - mulheres entre 25 e 64 anos
  if (item.idade >= 25 && item.idade <= 64) {
    if (item.a_pb == null || item.a_pb == 0) {
      pendencias.push('Exame colo do útero')
    }
  }

  // Vacinas (b_pb) - crianças e adolescentes entre 9 e 14 anos
  if (item.idade >= 9 && item.idade <= 14) {
    if (item.b_pb == null || item.b_pb == 0) {
      pendencias.push('Vacina HPV')
    }
  }

  // Consultas (c_pb) - adolescentes e mulheres entre 14 e 69 anos
  if (item.idade >= 14 && item.idade <= 69) {
    if (item.c_pb == null || item.c_pb == 0) {
      pendencias.push('Consulta saúde sexual')
    }
  }

  // Mama (d_pb) - mulheres entre 50 e 69 anos
  if (item.idade >= 50 && item.idade <= 69) {
    if (item.d_pb == null || item.d_pb == 0) {
      pendencias.push('Exame de mama')
    }
  }

  return pendencias.length > 0 ? pendencias.join(', ') : ''
}

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    callback: (item) => {
      let idade = `${utils.methods.formatDate(item.dt_nascimento)} (${
        item.idade
      } ${item.idade > 1 ? 'anos' : 'ano'})`
      return idade
    },
  },
  Mãe: 'no_mae',
  'M.Área': 'micro_area',
  Pendências: {
    callback: (item) => {
      return verificarPendencias(item)
    },
  },
}

export const infoHtml = ``

export const optionsFilterBoasPraticasLista = [
  {
    label: 'Todas',
    value: null,
    key: 'todas',
    key_percentual: 'todas',
  },
  {
    label: 'Exame colo útero',
    value: 'a_pb',
    key: 'colo-utero',
    key_percentual: 'colo_utero',
  },
  {
    label: 'Vacina HPV',
    value: 'b_pb',
    key: 'vacinas',
    key_percentual: 'vac',
  },
  {
    label: 'Consultas',
    value: 'c_pb',
    key: 'consultas',
    key_percentual: 'fai',
  },
  {
    label: 'Exame de mama',
    value: 'd_pb',
    key: 'mama',
    key_percentual: 'mama',
  },
]

export const optionsFilterBoasPraticasPercentual = [
  {
    label: 'Resultado indicador',
    value: null,
    key: 'resultado-indicador',
    key_percentual: 'resultado-indicador',
  },
  {
    label: 'Todas',
    value: null,
    key: 'todas',
    key_percentual: 'todas',
  },
  {
    label: 'Exame colo útero',
    value: 'a_pb',
    key: 'colo-utero',
    key_percentual: 'colo_utero',
  },
  {
    label: 'Vacina HPV',
    value: 'b_pb',
    key: 'vacinas',
    key_percentual: 'vac',
  },
  {
    label: 'Consultas',
    value: 'c_pb',
    key: 'consultas',
    key_percentual: 'fai',
  },
  {
    label: 'Exame de mama',
    value: 'd_pb',
    key: 'mama',
    key_percentual: 'mama',
  },
]
